module.exports = __webpack_public_path__ + "img/jl-aubert.261eb595.jpg";